<template>
  <div>
    <Header
      class="yh-header"
      active="/product"
      show-sub
      :sub-menu="subMenu"
      :product-value="productValue"
    >
      <template #left>
        <ImageAndName
          :image="util.getImageUrl(util.getHead(util.string2Array(get.images)), '48x48')"
          :name="get.name"
          :code="get.code"
        />
      </template>
      <template #right>
        <Feedback
          target-name="商品百科"
          :target-id="$route.params.id"
        />
        <Favourite
          target-name="product"
          :target-id="$route.params.id"
          :purchase-level="0"
        />
      </template>
    </Header>
    <div style="height: 130px" />
    <ProductBase
      class="yh-main"
      :get="get"
      :category="category"
    />
    <div style="min-height: 70px" />
  </div>
</template>

<script>
import Header from '@/components/Header'
import ProductBase from '@/components/ProductBase.vue'
import Favourite from '@/components/Favourite.vue'
import ImageAndName from '@/components/ImageAndName.vue'
import Feedback from '@/components/Feedback'

export default {
  name: 'ProductBaike',
  components: {
    Header,
    ProductBase,
    Favourite,
    ImageAndName,
    Feedback
  },
  data() {
    return {
      subMenu: [
        {
          name: '商品百科',
          path: `/product/baike/${this.$route.params.id}`,
          active: true
        },
        {
          name: '供应链信息',
          path: `/product/chain/${this.$route.params.id}`,
          active: false
        },
        {
          name: '数据看板',
          path: `/product/dashboard/${this.$route.params.id}`,
          active: false
        }
      ],
      category: '',
      productValue: this.util.getVariantSession('tagId')
    }
  },
  computed: {
    get() {
      return this.$store.state.product.productBase.get
    },
    collect() {
      return this.$store.state.user.userFavorite.retrieve.results.length > 0
        ? 1
        : 0
    }
  },
  async created() {
    await this.$store.dispatch('productBasePage', {
      packageName: 'product',
      className: 'productBase',
      methodName: 'get',
      params: {
        id: this.$route.params.id
      }
    })

    const response = await this.ajax.doPost({
      packageName: 'product',
      className: 'productCategory',
      methodName: 'getCategoryByCode',
      params: {
        code: this.get.categoryCode
      }
    })

    this.category = Array.isArray(response) ? response.map(e => e.name) : []

    this.$store.dispatch('productBaseUpdateViewCount', {
      packageName: 'product',
      className: 'productBase',
      methodName: 'updateViewCount',
      params: {
        id: this.$route.params.id
      }
    })

    this.$store.dispatch('createHistory', {
      packageName: 'user',
      className: 'userHistory',
      methodName: 'create',
      params: {
        targetName: 'product',
        targetId: this.$route.params.id
      }
    })

    this.ajax.doPost({
      packageName: 'user',
      className: 'userAnalysis',
      methodName: 'create',
      params: {
        userId: this.$store.state.sys.sysUser.me.id,
        moduleName: '商品百科-详情',
        moduleResourceId: this.$route.params.id,
        path: this.$route.path
      }
    })
  }
}
</script>

<style lang="less" scoped>
.el-header {
  box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.06);
}
.container {
  width: 1140px;
  margin: 5px auto;
}
.el-breadcrumb {
  width: 1100px;
  margin: 0 auto;
  padding: 20px 0;
  border-bottom: 1px solid #eee;
}
.el-main {
  position: relative;
  padding-top: 0;
}
// .fav {
//   position: absolute;
//   right: 20px;
//   top: 20px;
// }
</style>
